import { createRouter, createWebHistory } from 'vue-router';
import SignInView from '@/views/SignInView.vue';
import HomeView from '@/views/HomeView.vue';
import SettingsView from '@/views/ProfileView.vue';
import SelectMeterView from '@/views/SelectMeterView.vue';
import { useCredentialsStore } from '@/stores/credentials.js';
import StatView from '@/views/StatView.vue';
import SupportView from '@/views/SupportView.vue';
import { useMetersStore } from '@/stores/meters.ts';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { name: 'sign-in', path: '/sign-in', component: SignInView },
    { name: 'home', path: '/', component: HomeView },
    { name: 'stats', path: '/stats', component: StatView },
    { name: 'support', path: '/support', component: SupportView },
    { name: 'settings', path: '/settings', component: SettingsView },
    { name: 'select-meter', path: '/select-meter', component: SelectMeterView },
  ],
});

router.beforeEach((to) => {
  if (to.name !== 'sign-in' && !useCredentialsStore().isSignedIn) {
    return { name: 'sign-in' };
  } else if (
    to.name !== 'sign-in' &&
    to.name !== 'select-meter' &&
    (hasNoSelectedMeter() || useMetersStore().meterDetailsInvalid() || useMetersStore().meterDetailsExpired())
  ) {
    return { name: 'select-meter' };
  }
});

function hasNoSelectedMeter() {
  return (
    useCredentialsStore().isSignedIn && useMetersStore().selectedMeter === null
  );
}

export default router;
